import { cssEscape } from "./css_escape";

// Logique de fiscalité partagée entre le panneau « Mes profils »
// (`profiles_controller`) et les simulations (`simulations_controller`, #529) :
// aligner le sélecteur de mode (résidence / investissement), déclencher le
// contrôleur `toggle` (scope `tax_program`) et resynchroniser le bouton de
// fiscalité + le comparateur de fiscalités.
//
// `dispatchElement` est l'élément sur lequel émettre l'évènement `toggle:set`
// (bubbling) : il doit être le contrôleur `toggle` lui-même ou l'un de ses
// descendants (sinon l'évènement ne l'atteint pas).
export function applyTaxProgramToggle(dispatchElement, form, criterias) {
    const taxProgram = criterias && criterias.tax_program ? String(criterias.tax_program) : null;
    if (!form || !taxProgram) return;

    const mainResidence = ["ptz", "no_dispositive_residence"].includes(taxProgram);
    // `investment_mode` ne porte que le MODE (`residence`/`invest`), distinct
    // de la fiscalité `tax_program` (qui peut, elle, valoir `no_dispositive_*`).
    const mode = mainResidence ? "residence" : "invest";

    form.querySelectorAll('[name="profile[investment_mode]"]').forEach((radio) => {
        const checked = radio.value === mode;
        radio.checked = checked;
        const label = radio.closest("label");
        if (label) label.classList.toggle("active", checked);
    });

    if (dispatchElement) {
        try {
            dispatchElement.dispatchEvent(
                new CustomEvent("toggle:set", {
                    bubbles: true,
                    detail: { scope: "tax_program", value: taxProgram },
                })
            );
        } catch (_) {}
    }

    emitTaxProgramChange(form, taxProgram);
}

// Émet un `change` (bubbling) sur le radio `criterias[tax_program]` chargé pour
// resynchroniser le bouton de fiscalité (`fiscality-mode`) et le comparateur
// (`invest-details`) — cf. #347. On n'émet pas d'`input` (qui déclencherait une
// persistance + un api-sync supplémentaire) : le recalcul est piloté ailleurs.
export function emitTaxProgramChange(form, taxProgram) {
    if (!form || !taxProgram) return;

    const selector = `input[name="${cssEscape("criterias[tax_program]")}"][value="${cssEscape(taxProgram)}"]`;
    const radio = form.querySelector(selector);
    if (!radio) return;

    radio.checked = true;
    try {
        radio.dispatchEvent(new Event("change", { bubbles: true }));
    } catch (_) {}
}
